import {timeIntervals} from '../componentsSettings/tableDetailedStats'
import moment from '../moment'
const getMinutesFromPgsqlInterval = diff => {
  let minutes = 0
  if (diff.includes('day')) {
    let days = parseInt(diff)
    minutes += days * 24 * 60
    // cut days string from diff
    diff = diff.substr(diff.indexOf(' ') + 1)
    diff = diff.substr(diff.indexOf(' ') + 1)
  }
  let time = moment(diff, 'HH:mm:ss')
  minutes += parseInt(time.format('m'))
  minutes += parseInt(time.format('H')) * 60
  return minutes
}

const workshopFormatter = ordersStats => {
  // let ordersStats = JSON.parse(json)
  let filteredStats = []
  let totalTasksCount = 0
  if (ordersStats) {
    timeIntervals.forEach(interval => {
      if (!interval.avg) {
        let stats = ordersStats.filter(
          item => {
            return (getMinutesFromPgsqlInterval(item.diff) >= interval.min &&
                    (interval.max ? (getMinutesFromPgsqlInterval(item.diff) < interval.max) : true))
          }
        )
        // stats.forEach(item => {
        //   console.log('minutes', getMinutesFromPgsqlInterval(item.diff))
        // })

        filteredStats.push({
          title: interval.title,
          stats: {
            count: stats.length,
            sum: stats.reduce((sum, val) => sum + val.sum, 0)
          }
        })
        totalTasksCount = filteredStats.reduce((sum, item) => {
          return sum + item.stats.count
        }, 0)
        // let sumItems = 0
        filteredStats = filteredStats.map((item) => {
          // sumItems += item.stats.count
          item.stats.percent = item.stats.count / totalTasksCount * 100
          return item
        })
      } else {
        let statsLength = ordersStats.length
        filteredStats.push({
          title: interval.title,
          stats: {
            count: statsLength,
            sum: (
              statsLength > 0
                ? (ordersStats.reduce((sum, ord) => {
                  return sum + ord.sum
                }, 0))
                : 0
            ),
            avg: (
              statsLength > 0
                ? (
                  ordersStats.reduce((sum, ord) => {
                    return sum + getMinutesFromPgsqlInterval(ord.diff)
                  }, 0) / statsLength
                )
                : 0
            ).toFixed(2)
          }
        })
      }
    })
  } else {
    timeIntervals.forEach(interval => {
      filteredStats.push({
        title: interval.title,
        stats: {
          count: 0,
          sum: 0,
          avg: interval.avg ? 0 : undefined
        }
      })
    })
  }
  return filteredStats
}

export {workshopFormatter}



// WEBPACK FOOTER //
// ./src/helpers/tableDetailedStats.js